import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  background-color: #191a1d;
  overflow: hidden;
`;

export const Report = styled.div`
  margin: 0 auto;
  width: 328px;
  padding: 40px 0;
  ${DESKTOP} {
    width: 1000px;
    padding: 48px 0;
  }
`;

export const GraduateResult = styled(Report)`
  padding: 0;
  ${DESKTOP} {
    display: flex;
    justify-content: space-between;
  }
`;

export const Divider = styled.div`
  ${DESKTOP} {
    width: 1000px;
    margin: 0 auto;
    height: 1px;
    background-color: #333333;
  }
`;

export const MobileDivider = styled.div`
  margin: 40px auto;
  height: 1px;
  background-color: #333333;
  width: 328px;
  ${DESKTOP} {
    display: none;
  }
`;

export const Share = styled(Report)`
  padding: 0 0 40px;
  ${DESKTOP} {
    padding: 40px 0 60px;
  }
`;
